import type React from 'react';

import { inject, observer } from 'mobx-react';

import { faUserCircle } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import useComputed from 'bz-utilities/hooks/computed';

import type UserDialogFormStore from 'modules/settings/controls/setup/controls/users/controls/user-dialog/stores/users-dialog-store';
import Avatar from './controls/avatar';
import Status from './controls/status';

export interface IProps {
  formStore?: UserDialogFormStore;
}

const ClickUserProfile = inject('formStore')(
  observer<React.FC<IProps>>(({ formStore }) => {
    const userName: string = useComputed(() => {
      const names = [formStore!.get('firstName'), formStore!.get('lastName')]
        .filter(BzNotFalsy)
        .join(' ');

      if (!!names) {
        return names;
      }

      return 'User Name';
    }, [formStore]);

    const isActive: boolean = useComputed(() => {
      // assuming this is a string the same way the old code does - TD
      const value = formStore!.get('current');

      return value?.toString().toUpperCase() === 'TRUE';
    }, [formStore]);

    return (
      <div className="borderxxx h-full w-full">
        <Avatar avatar={formStore!.get('avatar')} id={formStore!.get('id')} />
        <div className="flex flex-wrap items-center justify-between border-t-2 border-gray-200 p-5">
          <div>
            <h1 className="text-xl font-bold text-gray-800">{userName}</h1>
            <h3 className="text-base font-medium text-gray-600 opacity-75">
              {formStore!.get('email') ?? 'User email'}
            </h3>
          </div>
          <div>
            <Status isActive={isActive} />
          </div>
        </div>
      </div>
    );
  })
);

ClickUserProfile.wrappedComponent.displayName = 'ClickUserProfile';

export default ClickUserProfile;
